import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { toDataURL } from 'qrcode';

/**
 * The QR Code component presents a QR Code to the user.
 *
 * To modify its size, set the size of the `<nom-qrcode>` element.
 *
 * @example Provide a QR Code
 * nom-qrcode {
 *   max-width: 200px;
 * }
 * <nom-qrcode [data]="someWebsiteUrl"></nom-qrcode>
 */
@Component({
    selector: 'nom-qrcode',
    templateUrl: './qrcode.component.html',
    styleUrls: ['./qrcode.component.scss'],
    standalone: false
})
export class QrcodeComponent implements OnChanges {
  /**
   * The data to display in this QR Code.
   */
  @Input() public data: string | undefined;

  /**
   * The data URI representing the QR code image itself.
   * @internal
   */
  public imageDataUri: string | undefined;

  /**
   * Update the image data URI whenever the data input changes.
   * @param changes The input changes
   * @internal
   */
  public ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      if (this.data) {
        toDataURL(this.data).then(value => {
          this.imageDataUri = value;
        })
      } else {
        this.imageDataUri = undefined;
      }
    }
  }
}
